import styled, { css } from 'styled-components';
import { borderRadius, BorderRadiusProps } from 'styled-system';
import { backgroundColor } from './system';

export const StyledLoader = styled.div<
  {
    width?: number;
    height?: number;
    backgroundColor: string;
  } & BorderRadiusProps
>`
  overflow: hidden;
  position: relative;
  display: block;
  max-width: 100%;

  ${borderRadius};
  width: ${(props) => (props.width ? props.width + 'px' : '100%')};
  height: ${(props) => (props.height ? props.height + 'px' : '20px')};

  ${backgroundColor};

  ${({ theme }) => css`
    &:before {
      background: linear-gradient(
        to right,
        transparent,
        ${theme.colors.white.main},
        transparent
      );
    }
  `};

  &:before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    transform: translateX(-100%);
    animation: loading 1.5s infinite;
  }

  @keyframes loading {
    100% {
      transform: translateX(100%);
    }
  }
`;
